const cardIcon = (type) => {
    return original[type]
}

const original = {
    'Mastercard': 'mastercard',
    'Visa': 'visa',
    'Visa Electron': 'visa',
    'American Express': 'amex',
    'Diners Club Carte Blanche': 'diners-club',
    'Discover': 'discover',
    'JCB': 'jcb'
}

export {
    cardIcon
}